import { render, staticRenderFns } from "./BrbEmptyView.vue?vue&type=template&id=66ff1e78&"
import script from "./BrbEmptyView.vue?vue&type=script&lang=js&"
export * from "./BrbEmptyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ff1e78')) {
      api.createRecord('66ff1e78', component.options)
    } else {
      api.reload('66ff1e78', component.options)
    }
    module.hot.accept("./BrbEmptyView.vue?vue&type=template&id=66ff1e78&", function () {
      api.rerender('66ff1e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/BrbEmptyView.vue"
export default component.exports